import {settingsBlockedUserPath} from '@github-ui/paths'
import {verifiedFetch} from '@github-ui/verified-fetch'

export async function unblockUserPersonally(userLogin: string): Promise<void> {
  const response = await verifiedFetch(settingsBlockedUserPath({login: userLogin}), {
    method: 'DELETE',
    redirect: 'manual',
  })

  if (!response.ok && response.type !== 'opaqueredirect') {
    throw new Error('Failed to unblock user')
  }
}
